__webpack_require__.p = "https://shop.swirepay.com/";